define.alias("shared/models/fb-post", "media/models/fb-post");